module.exports = __webpack_public_path__ + "static/img/ent-detail-48.2ef27c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-48.jpg
// module id = Rxiu
// module chunks = 52